<template>
  <div class="body_wrapper">
    <h2 class="trace-title">{{ info.fieldName }}</h2>
    <h4 class="trace-subtitle">{{ info.operateTime }}</h4>
    <div class="tag-list">
      <div class="tag-list-li" v-for="(v, index) in info.attaches" :key="index">
        <h5 class="tag-list-li-title" v-if="v?.urls?.length > 0">
          {{ v.name }}
        </h5>
        <div
          class="img-card"
          v-for="(w, wIndex) in v.urls"
          :key="wIndex"
          :style="{ 'background-image': `url(${w})` }"
        ></div>
      </div>
    </div>
    <div class="img-card_wrapper"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      info: {}
    };
  },
  props: {},
  mounted() {
    try {
      this.info = JSON.parse(this.$route.query.info);
    } catch (error) {
      console.error(this.$route.query.info);
    }
  }
};
</script>

<style lang="less" scoped>
body {
  height: 100%;
}
.body_wrapper {
  height: 100%;
  background-color: white;
  overflow: auto;
  padding: 20px 10px;
}
.trace-title {
  font-size: 16px;
  line-height: 2;
}
.trace-subtitle {
  font-size: 14px;
  line-height: 2;
  font-weight: normal;
  color: gray;
}
.tag-list {
  margin-top: 20px;
}
.tag-list-li-title {
  color: gray;
  line-height: 3;
  font-weight: normal;
}
.img-card {
  width: 100%;
  overflow: hidden;
  text-align: center;
  height: 200px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0px 0px 7px #b7b7b7;
}
</style>
